import React, { useEffect } from 'react';
import ReactGA from "react-ga4";

const InternalServerError= () => {
  useEffect(() => {
    ReactGA.send({ 
      hitType: "pageview", page: window.location.pathname });
    }, []);

    return (
        <div className="error-container">
        <h1 className="text-center text-fade-color">Error 500</h1>
        <div className="error-message">
          <img className="error-icon" src="../500.png" alt="Error 500" />
          <h2 className="text-color">Sorry...</h2>
          <h4 className="text-color mb-0">We have some troubles with our server.</h4>
          <p className="text-color mb-0">Refresh the site or feel free to contact us.</p>
          <div className="error-buttons">
            <a className="btn btn-primary " href="/">Home</a>
            <a className="btn btn-outline-secondary " href="https://www.navmatix.com/contact/#form" target="_blank" rel="noopener noreferrer">Contact us
            </a>
          </div>
        </div>
      </div>
    )
}

export default InternalServerError;